import { jsxs, jsx } from "react/jsx-runtime";
import { useFocusRing } from "@react-aria/focus";
import styled, { css } from "styled-components";
import { textStyles } from "./textStyles.js";
import { token } from "./token.js";
const pointerEventsClassname = "ds-switch__pointer-events-wrapper";
function Switch({
  children,
  isChecked,
  isDisabled,
  inputProps,
  onChange = () => {
  },
  // eslint-disable-line @typescript-eslint/no-empty-function
  ...props
}) {
  const {
    isFocusVisible,
    focusProps
  } = useFocusRing();
  return /* @__PURE__ */ jsxs(SwitchStyled, {
    $isDisabled: isDisabled,
    className: pointerEventsClassname,
    ...props,
    children: [children && /* @__PURE__ */ jsx(Label, {
      children
    }), /* @__PURE__ */ jsx(ToggleAlignment, {
      children: /* @__PURE__ */ jsxs(Toggle, {
        children: [/* @__PURE__ */ jsx("input", {
          role: "switch",
          type: "checkbox",
          disabled: isDisabled,
          onChange,
          checked: isChecked,
          "aria-checked": isChecked,
          ...focusProps,
          ...inputProps
        }), /* @__PURE__ */ jsx(Indicator, {
          "aria-hidden": "true",
          $isDisabled: isDisabled,
          $isFocusVisible: isFocusVisible
        })]
      })
    })]
  });
}
Switch.pointerEventsClassname = pointerEventsClassname;
const SwitchStyled = styled.label.withConfig({
  displayName: "SwitchStyled",
  componentId: "sc-1tgwl0j-0"
})(["", " display:flex;align-items:baseline;margin:0;padding:", " 0;color:", ";cursor:", ";user-select:none;"], textStyles.uiTextM, token.spacing1, token.colorText, (props) => !props.$isDisabled && "pointer");
const Label = styled.span.withConfig({
  displayName: "Label",
  componentId: "sc-1tgwl0j-1"
})(["align-self:center;margin-right:", ";"], token.spacing4);
const ToggleAlignment = styled.span.withConfig({
  displayName: "ToggleAlignment",
  componentId: "sc-1tgwl0j-2"
})(["margin-left:auto;&::before{content:'\\200B';display:inline-block;vertical-align:middle;}"]);
const Toggle = styled.span.withConfig({
  displayName: "Toggle",
  componentId: "sc-1tgwl0j-3"
})(["position:relative;display:inline-block;vertical-align:middle;width:36px;height:22px;input{position:absolute;opacity:0;}"]);
const pointerEventsClassnameSelector = "." + pointerEventsClassname;
const Indicator = styled.span.withConfig({
  displayName: "Indicator",
  componentId: "sc-1tgwl0j-4"
})(["position:absolute;top:0;right:0;bottom:0;left:0;box-sizing:border-box;width:100%;height:100%;border-radius:", ";background:", ";cursor:", ";transition:0.2s;&::before{content:'';position:absolute;right:calc(100% - 20px);bottom:2px;left:2px;height:18px;border-radius:50%;background-color:", ";box-shadow:", ";transition:0.2s;}", " input:checked + &&{background-color:", ";opacity:", ";&::before{right:2px;left:calc(100% - 20px);background-color:", ";}}", " ", ":hover &&,", ":focus-visible &&{background-color:", ";}", ":hover input:checked + &&,", ":focus-visible input:checked + &&{background-color:", ";}", ""], token.radiusPill, (props) => props.$isDisabled ? token.gray100 : token.gray75, (props) => !props.$isDisabled && "pointer", (props) => props.$isDisabled ? token.gray50 : token.gray10, token.elevation2, Toggle, (props) => props.$isDisabled ? token.gray400 : token.blue500, (props) => props.$isDisabled ? `0.5` : `1`, (props) => props.$isDisabled ? token.gray100 : token.gray10, (props) => !props.$isDisabled && css(["", ":active input + &&::before{right:calc(100% - 24px);left:2px;border-radius:9px;}", ":active input:checked + &&::before{right:2px;left:calc(100% - 24px);}"], pointerEventsClassnameSelector, pointerEventsClassnameSelector), pointerEventsClassnameSelector, pointerEventsClassnameSelector, token.gray100, pointerEventsClassnameSelector, pointerEventsClassnameSelector, (props) => props.$isDisabled ? token.gray400 : token.blue600, (props) => props.$isFocusVisible && css(["", " input + &&{background-color:", ";&::after{content:'';position:absolute;top:-3px;right:-3px;bottom:-3px;left:-3px;border:2px solid ", ";border-radius:100px;}}", " input:checked + &&::after{border-color:", ";}"], Toggle, token.gray100, token.gray200, Toggle, token.blue500));
export {
  Switch
};
//# sourceMappingURL=Switch.js.map
